import { useEffect } from 'react'

import { useAiChat } from '@factorialco/f0-react/dist/experimental'

export const useAutoOpenChat = () => {
  const { open, setOpen } = useAiChat()

  useEffect(() => {
    const initiallyOpen = open

    if (!initiallyOpen) {
      setOpen(true)
    }

    return () => {
      if (!initiallyOpen) {
        setOpen(false)
      }
    }
  }, [])
}
